import api from "../../../services/api.service"


export const vipClubModule = {
    namespaced: true,
    state: {
        data: {types:[],categories:[]},
    },
    getters: {
        hasVipClubAdmin(state, getters, rootState, rootGetters) {
            return rootGetters['user/canOperate']('vipclubAdmin');
        },
        canReadRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canRead']('real_estate');
        },
        canEditRealEstate(state, getters, rootState, rootGetters) {
            return rootGetters['user/canEdit']('real_estate');
        },
        getAllCategories(state) {
            if (state.data == null || state.data.categories == null)
                return [];
            return state.data.categories;
        },

        getAllTypes(state) {
            if (state.data == null || state.data.types == null)
                return [];
            return state.data.types;
        },
        allStatusNoActive() {
            return [
                {value: "NEW", text: 'NEW'},
                {value: 'EXPOSE', text: 'EXPOSE'},
                {value: 'DISABLED', text: 'DISABLED'}
               ]
        },
        allStatus() {
            return [
                {value: "NEW", text: 'NEW'},
                {value: 'EXPOSE', text: 'EXPOSE'},
                {value: 'ACTIVE', text: 'ACTIVE'},
                {value: 'DISABLED', text: 'DISABLED'}
               ]
        },


    },
    mutations: {
        updateData(state, data) {
            let stateData = {};
            stateData.loaded = true;
            stateData.categories = data["Categories"];
            stateData.types = data["Types"];
            state.data = stateData;
        }
    },
    actions: {
        getData({state, commit, dispatch}) {
            return new Promise(function (resolve, reject) {
                api.sendRequest('realEstate/data').then(
                    (ans) => {

                        commit('updateData', ans);
                        resolve(state);
                    }, (error) => {
                        dispatch('notifications/error',
                            {
                                title: 'Getting data',
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                        reject(error.message)
                    })
            })
        },
        copySuccess(actions,id){
            actions.dispatch('notifications/success',
                {title: 'Success', message: 'VipClub  ID '+id+' copied'},
                {root: true});

        },

        getAllVipClubs(actions,{ page, amount, filter,sortcolumn, sortby }) {

            return new Promise(function (resolve, reject) {
                actions.dispatch('getData', false).finally(() => {
                    api.sendRequest('vipClub/get', {
                        buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
                        page,
                        amount,
                        sortcolumn,
                        sortby
                    },filter).then(
                        (ans) => {
                            if (ans["VipClubs"] == null)
                                return reject('Could not get VipClubs members ');

                            resolve(ans);
                        }, (error) => {
                            reject(error.message)
                        })
                })

            })
        },

        getVipClubById(actions,id){
            return new Promise((resolve, reject) => {

                api.sendRequest('vipClub/id/'+id, {}).then(
                    (ans) => {

                        if (ans["VipClub"] == null)
                            return reject('Could not get vipClub member ');

                        resolve(ans["VipClub"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        sendEmail(actions,vipClub){
            return new Promise((resolve, reject) => {

                api.sendRequest('vipClub/sendEmail',null, vipClub).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Email Support', message: 'Email was sent successfully'},
                            {root: true});

                        if (ans["RowsUpdated"] == null)
                            return reject('Could not sent email');

                        resolve(ans["RowsUpdated"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        sendRegMail(actions,{vipClubId}){

            return new Promise(function (resolve, reject) {
                api.sendRequest('vipClub/sendRegistrationMail/'+vipClubId,
                    {}).then(
                    (ans) => {
                        if (ans["VipClub"] == null)
                            return reject('Could not send email ');

                        actions.dispatch('notifications/success',
                            {title: 'Welcome email', message: 'Email sent successfully'},
                            {root: true});

                        resolve(ans["VipClub"]);
                    }, (error) => {

                        actions.dispatch('notifications/error',
                            {
                                title: 'Welcome email couldnt be sent',
                                message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                            },
                            {root: true});
                        reject(error.message)
                    })
            })

        },

        updateVipClub(actions,vipClub){
            return new Promise((resolve, reject) => {

                api.sendRequest('vipClub/update',null, vipClub).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Update vipClub', message: 'Vip Club member updated successfully'},
                            {root: true});

                        if (ans["VipClubId"] == null)
                            return reject('Could not update vipClub member ');

                        resolve(ans["VipClubId"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },
        addVipClub(actions,vipClub){
            return new Promise((resolve, reject) => {
                api.sendRequest('vipClub/add', null,vipClub).then(
                    (ans) => {
                        actions.dispatch('notifications/success',
                            {title: 'Add vipClub', message: 'VipClub created successfully'},
                            {root: true});

                        if (ans["VipClubId"] == null)
                            return reject('Could not create vipClub member ');

                        resolve(ans["VipClubId"]);
                    }, (error) => {
                        reject(error.message)
                    })
            })
        },


    },
};
